import '@fortawesome/fontawesome-pro/js/all';

export const fontFamilyRoboto = `"Roboto", "Helvetica", "Arial", "sans-serif"`;
export const fontFamilyNoeDisplayBlack = `"NoeDisplay-Black", "Helvetica", "Arial", "sans-serif"`;
